import { FC } from 'react';
import { useTranslation } from '@packages/utils';
import { EWorkshopStatus } from 'data/types/workshops.types';
import { Flex } from 'antd';
import { ChildOutline } from 'assets/icon/icon';
import { Text } from 'components/Base/Typography';
import { TProvidingProps } from './Providing.types';
import Childcare from './Childcare/Childcare';
import Food from './Food/Food';
import { providingKey } from './Providing.data';

const Providing: FC<TProvidingProps> = ({
  childcareProvided,
  foodProvided,
  id,
  workshopStatus,
}) => {
  const needConfirmation = workshopStatus === EWorkshopStatus.PUBLISHED;
  const { t } = useTranslation({
    keyPrefix: providingKey,
  });

  return (
    <Flex align="center" gap={16}>
      <Flex align="center" gap={8} style={{ width: 160 }}>
        <ChildOutline size={24} />
        <Text color="#808080">{t('LABEL')}</Text>
      </Flex>
      <Flex align="center" gap={8}>
        <Food
          foodProvided={foodProvided}
          id={id}
          needConfirmation={needConfirmation}
        />
        <Childcare
          id={id}
          childcareProvided={childcareProvided}
          needConfirmation={needConfirmation}
        />
      </Flex>
    </Flex>
  );
};

export default Providing;
